import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TreatmentGroupHDModel } from 'src/app/models/TreatmentGroupHDModel';
import { TreatmentGroupHDService } from 'src/app/services/TreatmentGroupHDService';

@Component({
  selector: 'app-treatment-group-search',
  templateUrl: './treatment-group-search.component.html',
  styleUrls: ['./treatment-group-search.component.css']
})
export class TreatmentGroupSearchComponent implements OnInit {


tgcode = '' ;
tgname = '' ;
compcode = '1' ;
userid = '' ;



  treatmentGroup: TreatmentGroupHDModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<TreatmentGroupSearchComponent>,
    public TreatmentGroupHDService: TreatmentGroupHDService,
    public TreatmentGroup: TreatmentGroupHDModel,
    @Inject(MAT_DIALOG_DATA)
    public TreatmentGroupSelectedData: TreatmentGroupHDModel
  ) { }

  ngOnInit(): void {
    this.retriveTreatmentGroupLookUPTop();
  }

  retriveTreatmentGroupLookUPTop() {
       debugger;
    this.treatmentGroup = [];
    this.TreatmentGroupHDService.GetTreatmentGroupHDLookupTop(this.compcode).subscribe(
      (data: TreatmentGroupHDModel[]) => {

        for (let i = 0; i < data.length; i++) {
          this.treatmentGroup[i] = data[i];
        }
      }
    );
  }

  retriveTreatmentGroupLookUP() {
    this.treatmentGroup = [];
    this.TreatmentGroupHDService.GetTreatmentGroupHDLookUp(this.tgcode,this.tgname,this.compcode).subscribe((data: TreatmentGroupHDModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.treatmentGroup[i] = data[i];
      }
    });
  }

  SelectTreatmentGroup(TreatmentGroup: TreatmentGroupHDModel) {
    this.TreatmentGroupSelectedData.tgcode = TreatmentGroup.tgcode;
    this.TreatmentGroupSelectedData.tgname = TreatmentGroup.tgname;
    this.TreatmentGroupSelectedData.userid = TreatmentGroup.userid;
    this.TreatmentGroupSelectedData.compcode = TreatmentGroup.compcode;
    this.submitClicked.emit(this.TreatmentGroupSelectedData);
    this.dialogRef.close();
  }
}
